import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ApiService } from '../../../../../services/api.service';
import { FileUploadComponent } from '../../../../../common/file-upload/file-upload.component';
import { Subappalto } from '../../../../../shared/interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../../../../environments/environment';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-edit-subappalto-accrediti-backoffice',
  templateUrl: './edit-subappalto-accrediti-backoffice.component.html',
  styleUrls: ['./edit-subappalto-accrediti-backoffice.component.css']
})
export class EditSubappaltoAccreditiBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService, private confirmationService: ConfirmationService) {}

  @ViewChild('uploadVisuraCamerale', { static: false }) uploadVisuraCamerale!: FileUploadComponent;
  @ViewChild('uploadPos', { static: false }) uploadPos!: FileUploadComponent;

  @ViewChild('deleteVisuraCamerale') deleteVisuraCamerale!: ConfirmPopup;
  @ViewChild('deletePos') deletePos!: ConfirmPopup;

  @Input() visible: boolean = false;
  @Input() subappalto?: Subappalto;

  @Output() close = new EventEmitter<boolean>();
  
  formSubappalto!: FormGroup;

  ngOnInit(): void {
    this.formSubappalto = new FormGroup({
      ragione_sociale: new FormControl(null, Validators.required),
      piva: new FormControl(null, Validators.required),
      attivita: new FormControl(null, Validators.required),      
      visura_camerale: new FormControl(null),
      pos: new FormControl(null),
    });

    if (this.subappalto) {
      this.formSubappalto.patchValue({
        ragione_sociale: this.subappalto?.ragione_sociale,
        piva: this.subappalto?.piva,
        attivita: this.subappalto?.attivita,        
      })
    }
  }
  
  onClose() {
    this.visible = false;
    this.close.emit(this.visible);
  }

  onDocumento(documento: string) {
    const token = localStorage.getItem('teatro-colosseo-backoffice-auth-token') || '';
    const q = token ? `?type=documento&token=${encodeURIComponent(token)}` : '?type=documento';
    window.open(environment.apiURL + 'file/' + documento + q, "_blank");
  }

  onOpenDeleteDocumento(event: Event, documento: string) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Sei sicuro di voler rimuovere il documento caricato?`,
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteDocumentoSubappalto(this.subappalto!.id, documento).subscribe({          
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {

            if (documento == 'visura_camerale')
              this.subappalto!.visura_camerale = '';
            else if (documento == 'pos')
              this.subappalto!.pos = '';

            this.confirmationService.close();               
            this.apiService.message('success', 'Eliminazione', 'Il documento è stato rimosso con successo!');
          },
        });
      },
    });
  }

  onDeleteDocumento(tipo: string) {
    if (tipo == 'visura_camerale')
      this.deleteVisuraCamerale.accept();
    else if (tipo == 'pos')
      this.deletePos.accept();
  }

  onCloseDeleteDocumento(tipo: string) {
    if (tipo == 'visura_camerale')
      this.deleteVisuraCamerale.reject();
    else if (tipo == 'pos')
      this.deletePos.reject();
  }

  onEdit() {
    
    let subappalto = new FormData();
    
    subappalto.append("id_evento", (this.subappalto?.id_evento || 0).toString());
    subappalto.append('ragione_sociale', this.formSubappalto.get('ragione_sociale')?.value || '');
    subappalto.append('piva', this.formSubappalto.get('piva')?.value || '');
    subappalto.append('attivita', this.formSubappalto.get('attivita')?.value || '');    
    subappalto.append('visura_camerale', this.formSubappalto.get('visura_camerale')?.value || '');
    subappalto.append('pos', this.formSubappalto.get('pos')?.value || '');

    this.apiService.updateSubappalto(subappalto, this.subappalto!.id).subscribe({
      next: (data) => this.apiService.setSubappaltiEvento(this.subappalto!.id_evento),
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.uploadVisuraCamerale.clearUpload();
        this.uploadPos.clearUpload();

        this.formSubappalto.reset();
        this.formSubappalto.markAsUntouched();
        this.formSubappalto.markAsPristine();    

        this.onClose()
      }
    });    

  }
}
